import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ShipCustomerTracking from 'pages/ShipCustomerTracking';
import ShipShopeeTracking from 'pages/ShipShopeeTracking';
import PageError from 'pages/PageError';

const HomeRedirect = () => <Redirect to='/' />;

const routes = (
  <Switch>
    <Route exact path='/ship/:token?' component={ShipCustomerTracking} />
    <Route exact path='/shopee/:token?' component={ShipShopeeTracking} />
    <Route exact path='/' component={PageError} />
    <Route path='/' component={HomeRedirect} />
  </Switch>
);

export default routes;
